<template>
  <div class="attachments-upload-form mb-2">
    <b-row class="w-100 attachment-upload-rows">
      <b-col
        v-for="(_, index) in attachmentsUpload"
        :key="`attachment-upload-${index}`"
        cols="12"
        lg="6"
        class="mb-2"
      >
        <attachment-upload-row
          :value="attachmentsUpload[index]"
          :index="index"
          :media-types="mediaTypes"
          :can-remove="index !== 0"
          @input="onRowInput(index, $event)"
          @add="$emit('add')"
          @remove="$emit('remove', index)"
        />
      </b-col>
    </b-row>

    <div class="d-flex justify-content-start">
      <b-button
        variant="primary"
        @click="$emit('submit')"
      >
        <b-spinner
          v-if="loadAttachments"
          variant="primary"
          label="Loading..."
        />
        <span v-else>إضافة مرفقات</span>
      </b-button>
      <b-button
        class="ml-1"
        variant="outline-primary"
        @click="$emit('close')"
      >
        <span>إغلاق</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import AttachmentUploadRow from '@/components/AttachmentUploadRow.vue'

export default {
  name: 'AttachmentsUploadForm',
  components: {
    BRow,
    BCol,
    BButton,
    BSpinner,
    AttachmentUploadRow,
  },
  props: {
    attachmentsUpload: {
      type: Array,
      required: true,
    },
    mediaTypes: {
      type: Array,
      required: true,
    },
    loadAttachments: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRowInput(index, value) {
      this.$emit('update-row', { index, value })
    },
  },
}
</script>
